<div class="logo-intestazione" [style]="css_logo" (click)="tap($event)">

</div>